// VISINVOKE customer registration — shared launch switch + Desktop Command (DCC)
// acknowledgement copy. This file is COPY/CONFIG ONLY. It grants no entitlement,
// decides no access, and installs nothing. The VISINVOKE website remains the sole
// account authority; the existing backend endpoint POST /v1/auth/register enforces
// all account rules. No second account system is introduced.
//
// NOTE: DCC onboarding STATE (selected / downloaded) is NOT stored here or in the
// browser. It is persisted against the VISINVOKE account (users.dcc_selected /
// users.dcc_downloaded) and read via /v1/auth/me — the account is authoritative.

// --- Launch switch -------------------------------------------------------------
// Single source of truth for whether customer self-service registration is exposed.
//   true  -> /register renders and the login page shows the "Create Account" block.
//   false -> /register redirects to /login and the login page shows the pre-launch
//            lock notice ("Registration is not yet open…").
// Set REACT_APP_REGISTRATION_OPEN=true only in an authorised deployment to open it;
// unset, empty, false, and all other values keep registration locked.
export function registrationOpenFromValue(value) {
  return String(value || '').trim().toLowerCase() === 'true';
}

// Closed unless the deployment deliberately opts in. No production variable was changed in Unit H.
export const REGISTRATION_OPEN = registrationOpenFromValue(process.env.REACT_APP_REGISTRATION_OPEN);

// --- Desktop Command download destination --------------------------------------
// The VISINVOKE-hosted installer, served from the existing visinvoke-portal S3 bucket
// behind the existing app.visinvoke.com CloudFront distribution under the /downloads/
// prefix (same URL the DCC download page uses — a single download location, no new
// infrastructure). This is a plain browser download link; it installs nothing itself.
export const DCC_DOWNLOAD_URL = 'https://app.visinvoke.com/downloads/VISINVOKE-Desktop-Command-Centre-0.1.1.exe';

// --- Approved DCC acknowledgement copy -----------------------------------------
// Mirrors the owner-approved single source:
//   visinvoke-desktop-app/src/constants/desktop-requirement.json ("owner-copy-approved").
// Presented as an informational acknowledgement at signup. forceInstallBeforeAccountCreation
// is false in that source, so the acknowledgement never blocks account creation.
export const DCC_REQUIREMENT = {
  option: 'Install VISINVOKE Desktop Command',
  explanation:
    'VISINVOKE Desktop Command is required to securely run desktop-connected products, ' +
    'utilities, and advanced features from your VISINVOKE account.',
  points: [
    'Some free products may require VISINVOKE Desktop Command.',
    'Many paid products require VISINVOKE Desktop Command.',
    'VISINVOKE Desktop Command provides secure access and management.',
  ],
  // The single opt-in control label shown at signup (preference/confirmation only).
  downloadOptionLabel: 'Download VISINVOKE Desktop Command',
};
